import PatientPage from './PatientPage'

export default PatientPage
